// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOMEPAGE_BLOG_PHOTOS = "Fotky z pr\u00edspevkov";
export const PHOTOS_SHOW_MORE = "Viac pr\u00edspevkov...";
